import ReactDOM from 'react-dom';
import * as React from 'react';
import { withErrorInfo } from './logging.ts';

/**
 * This will mount React component `Component` in placeholder divs that have
 * a data-name of `name`.
 *
 * This is used by the ReactComponent.php class to indicate mount points.
 */
export default function fastInitializeComponent(name, Component, defaultProps = {}) {
   const funName = `fastReactInit${name}`;
   let hasRun = false;
   const fun = placeholder => {
      hasRun = true;
      console.time(name);
      let props = {
         ...defaultProps,
         ...JSON.parse(placeholder.getAttribute('data-props')),
      };

      withErrorInfo(() => ReactDOM.render(<Component {...props} />, placeholder), [
         'Error occurred while rendering',
         Component,
         'with props',
         props,
      ]);
      console.timeEnd(name);
   };
   window[funName] = fun;
   const registry = window.fastInitializeRegistry || {};
   const registered = registry[funName];
   if (registered instanceof Array) {
      registered.forEach(elem => fun(elem));
      registry[funName] = [];
   }

   // Add timeout to check that the component gets initialized.
   const timeout = 5000;
   window.setTimeout(() => {
      if (!hasRun) {
         console.error(`${name} was not initialized within ${timeout} ms`);
      }
   }, timeout);
}
